<template>
  <div class="order-part-base-container">
    <div class="form-base">
      <el-form inline size="mini" :model="formData" :rules="rules" ref="baseForm" :class="{disabled}">
        <div class="form-rows">
          <div v-if="formData.id">
            <div class="card-title">基本信息
              <el-link type="primary" icon="el-icon-refresh" @click="refresh()" v-if="formData.id"></el-link>
            </div>
            <div class="form-card">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="订单编号">
                    <div class="span-val"> {{ formData.order_no || '' }}</div>
                  </el-form-item>
                  <el-form-item label="建单人">
                    <span class="span-val"> {{ formData.creator || '' }}</span>
                  </el-form-item>
                  <el-form-item label="创建时间">
                    <span class="span-val"> {{ formData.created_at || '' }}</span>
                  </el-form-item>
                  <el-form-item label="最后修改时间">
                    <span class="span-val"> {{ formData.updated_at || '' }}</span>
                  </el-form-item>
                  <el-form-item>
                    <el-popover
                        placement="bottom-start"
                        width="1200"
                        trigger="click" @show="showLog">
                      <OrderLogs :order-no="formData.order_no" ref="refOrderLog"/>
                      <el-button slot="reference" type="text" icon="el-icon-document"
                                 v-if="userAuth.view_adv_order_logs_div">查看日志
                      </el-button>
                    </el-popover>

                  </el-form-item>
                </el-col>
                <el-col class="tags" :span="24">
                  <el-form-item label="">
                    <el-tag effect="plain" type="primary" v-if="formData.order_type==='regular'">
                      {{ orderTypeFormat(formData.order_type) }}
                    </el-tag>
                    <el-tag v-else type="danger" effect="plain">{{ orderTypeFormat(formData.order_type) }}</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag v-if="formData.bool_exec === 1" type="success" effect="plain">已执行</el-tag>
                    <el-tag v-else-if="formData.bool_exec === 0" type="warning" effect="plain">未执行</el-tag>
                    <el-tag v-else type="info">执行状态：未知</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag type="primary" effect="plain">回款状态:{{ payStatusFormat(formData.pay_status) }}</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag type="primary" effect="plain">发票申请: {{
                        invoiceStatusFormat(formData.invoice_status)
                      }}
                    </el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag v-if="formData.bool_undo === 1" type="warning" effect="plain">已撤单</el-tag>
                    <el-tag v-else-if="formData.bool_undo === 0" type="primary" effect="plain">未撤单</el-tag>
                    <el-tag v-else type="info" effect="plain">撤单：未知</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag v-if="formData.contract_filed === 1" type="success" effect="plain">已归档</el-tag>
                    <el-tag v-else-if="formData.contract_filed === 0" type="warning" effect="plain">未归档</el-tag>
                    <el-tag v-else type="info" effect="plain">归档状态：未知</el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag v-if="formData.is_mark === 1" type="success" effect="plain">
                      全案营销订单
                      （归属：
                      <to-order-detail v-if="formData.pid" :order="{order_no:formData.parent_order_no}"
                                       by-field="order_no" style="font-size: 12px;"/>
                      ）
                    </el-tag>
                    <el-tag v-if="formData.project_type===3" type="success" effect="plain">
                      普客打包订单
                      （归属：
                      <to-order-detail :order="{order_no:formData.parent_order_no}"
                                       :routerType="'puke'" by-field="order_no" style="font-size: 12px;"/>
                      ）
                    </el-tag>
                    <el-tag v-else type="success" effect="plain">常规订单</el-tag>

                  </el-form-item>
                  <el-form-item v-if="formData.pid" label="">
                    <el-tag type="success" effect="plain" :title="`父ID：${formData.pid}`">子订单
                    </el-tag>
                  </el-form-item>
                  <el-form-item label="">
                    <el-tag v-if="formData.bool_covenant" type="success" effect="plain" :title="`已上传合同附件`">
                      <span>有效订单
                      <span class="span-btn" type="primary" @click="handelPreviewFiles(formData)">查看附件</span>
                      </span>
                    </el-tag>
                    <el-tag v-else type="info" effect="plain" :title="`未上传合同附件`">无效订单</el-tag>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- 乙方信息 -->
          <div class="party-row" v-if="pt===1||type==='child'||pt===5">
            <party-b ref="partyB" class="card-model" :form-data="formData" :edit-field.sync="editField"
                   :disabled="disabledPartyAB"
                   @selectEditField="selectEditField"/>

            <!--  关联询单 pt=1 或者创建子单-->
            <part-base-inquiry ref="partBaseInquiry" class="card-model" :form-data="formData"
                               :edit-field.sync="editField"
                               :disabled="disabledPartyAB" :pt="pt"
                               @clearEditField="clearEditField" @refresh="refresh" @selectEditField="selectEditField"/>

          </div>
          <div v-else>
            <party-b ref="partyB" class="card-model" :form-data="formData" :edit-field.sync="editField"
                     :disabled="disabledPartyAB"
                     @selectEditField="selectEditField"/>
          </div>
          <!-- 客户信息 -->
          <party-a ref="partyA" class="card-model" :is-pre-executor="isPreExecutor" :form-data="formData"
                   :edit-field.sync="editField" :pt="pt"
                   :disabled="disabledPartyAB" :type="type"
                   @selectEditField="selectEditField" @clearEditField="clearEditField" @refresh="refresh"/>

          <part-covenant :form-data="formData"/>

          <!-- 订单信息 -->
          <div class="card-title">
            <span v-if="formData.pid" style="font-size: 1.1em;margin-right: 2px">子</span><span>订单信息</span>
          </div>
          <div class="form-card">
            <!-- 红人 -->
            <div class="card-title">红人信息</div>
            <div class="form-card">
              <el-row v-anchor="['artist_name','release_timestamp']">
                <el-col :span="24">
                  <el-form-item label="红人名称" prop="artist_name">
                    <div>
                      <el-select class="el-input-c"
                                 :key="key"
                                 v-model="formData.artist_id"
                                 @change="selectFavouriteBoy"
                                 placeholder="请选择红人"
                                 v-if="editField==='artist_name'||!formData.artist_name"
                                 @focus="selectEditField('artist_name')"
                                 filterable
                                 clearable>
                        <el-option-group :label="`网红（KOL）/ 经纪人(${kolOptions.length})`">
                          <el-option
                              v-for="item in kolOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            <span style="float: left">{{ item.label }}</span>
                            <span style="float: left; color: #8492a6; font-size: 13px"> / {{ item.agent_name }}</span>
                            <span style="float: left; color: #8492a6; font-size: 13px"> / {{ item.id }}</span>
                          </el-option>
                        </el-option-group>
                      </el-select>
                      <!--                      <div class="input-val disabledNick" v-else-if="formData.artist_name"  >-->
                      <!--                        <span class="artist_name " :title="formData.artist_id">{{ formData.artist_name }}</span>-->

                      <!--                      </div>-->
                      <!--                      :class="disabledNick?'disabledNick':''"-->
                      <div class="input-val"
                           @click="selectEditField('artist_name')" v-else>

                        <span class="artist_name" :title="formData.artist_id">{{ formData.artist_name }}</span>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="经纪人" prop="agent_name">
                    <el-input class="el-input-c"
                              v-model="formData.agent_name"
                              placeholder="请输入经纪人"
                              v-if="editField==='agent_name'||!formData.agent_name"
                              maxlength="32" show-word-limit/>
                    <div class="input-val" @click="selectEditField('agent_name')" v-else>
                      <span class="agent_name" :title="formData.agent_name">{{ formData.agent_name }}</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="执行" prop="executor_id">
                    <el-select v-model="formData.executor_id"
                               placeholder="请选择执行"
                               v-if="editField==='executor'||!formData.executor"
                               @change="selectedExecutor"
                               @focus="selectEditField('executor')"
                               filterable
                               clearable>
                      <el-option-group :label="`可选执行(${executorOptions?executorOptions.length:0})`">
                        <el-option v-for="(item, index) in executorOptions" :key="index" :label="item.label"
                                   :value="item.value"/>
                      </el-option-group>
                    </el-select>
                    <div class="input-val" @click="selectEditField('executor')" v-else>
                      <span class="executor">{{ formData.executor }}</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="发布日期" prop="release_timestamp">
                    <el-date-picker class="el-input-c" type="date"
                                    v-model="formData.release_timestamp"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy年MM月dd日"
                                    placeholder="选择发布日期"
                                    v-if="editField==='release_timestamp'||!formData.release_timestamp"
                    />
                    <div class="input-val" @click="selectEditField('release_timestamp')" v-else>
                      <span class="release_timestamp">{{
                          parseTime(formData.release_timestamp, '{y}年{m}月{d}日')
                        }}</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="下单日期" prop="created_timestamp">
                    <el-date-picker class="el-input-c" type="date"
                                    v-model="formData.created_timestamp"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy年MM月dd日"
                                    v-if="editField==='created_timestamp'||!formData.created_timestamp"
                                    placeholder="选择下单日期"/>
                    <div class="input-val" @click="selectEditField('created_timestamp')" v-else>
                      <span class="created_timestamp">{{
                          parseTime(formData.created_timestamp, '{y}年{m}月{d}日')
                        }}</span>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-form-item label="发布平台" prop="platforms" label-width="80px" class="custom-checkbox-form">
                  <div
                      v-if="editField==='platforms'||(Array.isArray(formData.platforms)&&formData.platforms.length===0)">
                    <el-checkbox-group v-model="formData.platforms">
                      <el-checkbox
                          @change="selectEditField('platforms')"
                          v-for="item in platformOptions"
                          :key="item.value"
                          :value="item.value"
                          :label="item.value" border>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div v-else>
                      <span class="platforms">
                        <el-tag effect="plain" v-for="(item,index) in formData.platforms" :key="index" size="small"
                                style="margin-right: 5px">
                          {{ item }}
                        </el-tag>
                      </span>
                    <el-button type="text" icon="el-icon-edit" class="edit-btn" @click="selectEditField('platforms')"/>
                  </div>
                </el-form-item>
              </el-row>

              <el-row>
                <el-form-item label="内容形式" prop="content_forms" label-width="80px" class="custom-checkbox-form">
                  <div
                      v-if="editField==='content_forms'||(Array.isArray(formData.content_forms)&&formData.content_forms.length===0)">
                    <el-checkbox-group v-model="formData.content_forms">
                      <el-checkbox
                          @change="selectEditField('content_forms')"
                          v-for="item in contentFormsOptions"
                          :key="item.value"
                          :value="item.value"
                          :label="item.label" border>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div v-else>
                      <span class="content_forms">
                        <el-tag effect="plain" v-for="(item,index) in formData.content_forms" :key="index" size="small"
                                style="margin-right: 5px">
                          {{ item }}
                        </el-tag>
                      </span>
                    <el-button type="text" icon="el-icon-edit" class="edit-btn"
                               @click="selectEditField('content_forms')"/>
                  </div>
                </el-form-item>
              </el-row>
              <el-row v-if="Array.isArray(formData.content_forms)&&formData.content_forms.indexOf('视频合集植入')>-1">
                <el-col :span="24">
                  <el-form-item label="坑位" label-width="80px">
                    <template slot="label">
                      <span class="bold-label">坑位</span> &nbsp;
                      <el-tooltip class="item" effect="dark" content="仅内容形式为“视频集合植入”的才可选坑位"
                                  placement="top-start">
                        <el-button type="text" icon="el-icon-info"></el-button>
                      </el-tooltip>
                    </template>
                    <el-radio-group v-model="formData.ad_space_id">
                      <el-radio :label="item.value" :value="item.value" v-for="(item,index) in adSpaceOptions"
                                :key="index" border>{{ item.label }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!isPureLive" class="ploy-row">
                <el-form-item :label="'策\u3000\u3000略'" prop="strategy_id">
                  <user-role-select
                      key="strategy_id"
                      v-if="editField==='strategy_name'||!formData.strategy_name" placeholder="请选择策略" multiple
                      :role-name="`Strategy`"
                      :user-id.sync="formData.strategy_id"
                      @selected="selectedUser"
                  />
                  <div class="input-val" @click="selectEditField('strategy_name')" v-else>
                    <span class="strategy">
                      {{ strategyNameLabel || '-' }}
                    </span>
                  </div>
                </el-form-item>
                <el-form-item :label="'媒\u3000\u3000介'" prop="medium_id">
                  <UserRoleSelect key="medium_id" :role-name="`Medium`"
                                  :user-id.sync="formData.medium_id"
                                  v-if="editField==='medium_name'||!formData.medium_name" placeholder="请选择媒介"
                                  @selected="selectedUser"
                  />
                  <div class="input-val" @click="selectEditField('medium_name')" v-else>
                    <span class="executor">{{ formData.medium_name }}</span>
                  </div>

                </el-form-item>
                <el-form-item :label="'策\u3000\u3000划'" prop="planner_id">
                  <UserRoleSelect
                      key="planner_id"
                      :role-name="`Planner`"
                      :user-id.sync="formData.planner_id"
                      v-if="editField==='planner_name'||!formData.planner_name" placeholder="请选择策划"
                      @selected="selectedUser"
                  />
                  <div class="input-val" @click="selectEditField('planner_name')" v-else>
                    <span class="planner">{{ formData.planner_name }}</span>
                  </div>
                </el-form-item>
              </el-row>
            </div>
            <!--        金额信息-->
            <div class="card-title">费用信息</div>
            <order-part-fee ref="partFee" :form-data="formData" :options-pay-methods="payMethodOptions"/>

            <div>
              <div class="card-title">费用计算公式
                <el-link @click="showCalcFormula=!showCalcFormula" type="primary">
                  <i style="font-size: 1.2em" :class="[showCalcFormula?'el-icon-arrow-up':'el-icon-arrow-down']"></i>
                </el-link>
              </div>
              <div class="form-card" v-show="showCalcFormula">
                <algorithm-list :propsAlgorithm="algorithm"></algorithm-list>
              </div>
            </div>
          </div>
        </div>

        <!--          操作-->
        <div class="op-row">
          <el-form-item>
            <el-button v-if="showOpRow" class="btn-operation btn-pink" :loading="onSubmitLoadding"
                       icon="el-icon-finished"
                       @click="onSubmit('baseForm')">{{ this.formData.id ? '修改' : '保存' }}
            </el-button>
            <el-button class="btn-operation btn-orange" :loading="onTmpSubmitLoadding"
                       @click="onTmpSubmit('baseForm')" icon="el-icon-video-pause" v-if="showOpRow&&!this.formData.id">
              暂存
            </el-button>
            <el-button class="btn-operation btn-pink-border" @click="goBack" icon="el-icon-arrow-left">返回</el-button>
            <el-button class="btn-operation btn-pink" @click="goNewAdd" v-if="showAddBtn" icon="el-icon-plus">新增
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import PartyA from "@/views/adOrder/components/detail/PartBasePartyA";
import PartyB from "@/views/adOrder/components/detail/PartBasePartyB";
import PartBaseInquiry from "@/views/adOrder/components/detail/PartBaseInquiry";
import {postOrdersVerifyUnique} from "@/api/adOrder";
import {getOptionExecutor, getOptionItems, getOptionRadios} from "@/api/option";
import {getFBoyOption} from "@/api/fboy";
import {createOrder, temporariesList, temporariesSave} from "@/api/order";
import OrderLogs from "../../components/detail/OrderLogs";
import ToOrderDetail from "../../components/ToDetail";
import UserRoleSelect from "@/components/user/UserRoleSelect.vue";
import {algorithm} from "@/views/adOrder/algorithm";
import PartCovenant from "@/views/adOrder/components/detail/PartCovenant.vue";
import AlgorithmList from '@/views/adOrder/components/AlgorithmList.vue'
import OrderPartFee from "@/views/adOrder/order/components/fee/index.vue";

export default {
  name: "PartBase",
  components: {
    OrderPartFee,
    PartCovenant, UserRoleSelect, OrderLogs, PartyA, PartyB, PartBaseInquiry, ToOrderDetail, AlgorithmList
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default() {
        return 'add'
      }
    },
    showAddBtn: {
      type: Boolean,
      default() {
        return false
      }
    },
    disabledNick: {
      type: Boolean,
      default() {
        return false
      }
    },
    isPreExecutor: {
      type: Boolean,
      default() {
        return false
      }
    },
    pt: Number,
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
    kind() {
      let kind = this.$route.query.kind || ''
      if (!kind) {
        if (this.formData.pid || this.$route.query.source_id || this.formData.puke_id || this.isPureLive) {
          kind = ''
        } else {
          kind = 'RegularOrder'
        }
      }
      return kind
    },
    isPureLive() {
      // 是“纯直播”
      const {isPureLive} = this.$route.query
      return isPureLive && isPureLive === 'true'
    },
    showOpRow() {
      // can_update_executed_order
      // 创建：拥有建单权限
      // 修改：1）拥有修改权限 2）若已执行，则需要【编辑已执行的订单】-can_update_executed_order
      if (this.formData.id) {
        if (this.formData.bool_exec === 1) {
          return this.userAuth.can_update_executed_order
        } else
          return this.userAuth.can_update_adv_order
      } else {
        return this.userAuth.can_create_adv_order
      }
      // return (this.userAuth.can_create_adv_order && !this.formData.id) || (this.formData.id && this.userAuth.can_update_adv_order);
    },
    disabledPartyAB() {
      return !!(this.formData.is_mark && this.formData.pid)
    },
    needGetKol() {
      // 创建子订单 || 编辑子订单 optionsArtist
      const route_name = this.$route.name
      const {is_mark, pid} = this.formData
      if (is_mark) {
        // 全案营销
        if (route_name === 'editAdOrder' || route_name === 'createAdOrder') {
          if (pid > 0) {
            // 全案营销子订单
            return false
          }
        }
      }

      return true
    }
  },
  watch: {
    "formData.strategy_name": {
      handler(val) {
        if (!val) {
          this.strategyNameLabel = null;
        } else if (Array.isArray(val)) {
          this.strategyNameLabel = val.join('、');
        } else {
          this.strategyNameLabel = val;
        }
      },
      deep: true
    },
    "formData.platforms"(array) {
      this.calRepelCheckValue(array, 'platforms')
    },
    "formData.content_forms"(array) {
      this.calRepelCheckValue(array, 'content_forms')
    },
  },
  data() {
    return {
      algorithm,
      key: new Date().getTime() + '',
      dialogCustomerVisible: false,
      showCalcFormula: false,
      editField: '',//当前编辑的字段
      editFieldMoneyAchievement: false, // 编辑整单业绩金额
      customerListDisplay: false,
      onSubmitLoadding: false,
      onTmpSubmitLoadding: false,
      strategyNameLabel: null,
      tmpOrders: [],
      executorOptions: [],
      kolOptions: [],//KOL选项
      platformOptions: [],//平台选项
      contentFormsOptions: [],//内容形式
      payMethodOptions: [],//支付方式
      radioOptions: [],//单选选项
      optionsItem: [
        'customer_types',
        'customer_natures',
        'content_forms',
        'ad_space',
        'order_source',
        'platforms',
        'pay_methods',
        'form_of_cooperation',
        'product_category',
        'passenger_order_interval',
      ],
      errorRebateRate: false,
      rules: {
        company_id: [
          {required: true, message: '请输入乙方公司名称', trigger: 'change'},
        ],
        customer_name: [
          {required: true, message: '请输入客户姓名', trigger: 'change'},
        ],
        customer_nature: [
          {required: true, message: '请选择客户性质', trigger: 'change'},
        ],
        sale_id: [
          {required: true, message: '请选择销售', trigger: 'change'},
        ],
        executor_id: [
          {required: true, message: '请选择执行', trigger: 'change'},
        ],
        brand: [
          {required: true, message: '请输入品牌名称', trigger: 'blur'},
        ],
        release_timestamp: [
          {required: true, message: '选择发布日期', trigger: 'blur,change'},
        ],
        created_timestamp: [
          {required: true, message: '选择下单日期', trigger: 'blur,change'},
        ],
        order_source: [
          {required: true, message: '选择订单来源', trigger: 'change'},
        ],
        trade: [
          {required: true, message: '请选择行业名称', trigger: 'blur,change'},
        ],
        place_of_origin: [
          {required: true, message: '请输入产地', trigger: 'blur'},
        ],
        product: [
          {required: true, message: '请输入产品名称', trigger: 'blur'},
        ],
        artist_name: [
          {required: true, message: '请选择红人', trigger: 'change'},
        ],
        agent_name: [
          {required: true, message: '请输入经纪人', trigger: 'blur'},
        ],
        platforms: [
          {required: true, message: '请选择平台', trigger: 'change'},
        ],
        content_forms: [
          {required: true, message: '请选择内容形式', trigger: 'change'},
        ],
        payed_timestamp: [
          {required: true, message: '请选择结款时间', trigger: 'change'},
        ],
        pay_method: [
          {required: true, message: '请选择付款方式', trigger: 'change'},
        ],
        pay_term: [
          {required: true, message: '请选择付款方式', trigger: 'change'},
        ],
        form_of_cooperation: [
          {required: true, message: '请选择合作形式', trigger: 'change'},
        ],
        product_category: [
          {required: true, message: '请选择品类', trigger: 'change'},
        ],
        passenger_order_interval: [
          {required: true, message: '请选择客单', trigger: 'change'},
        ],
        payment_account: [
          {required: true, message: '请输入含税收入', trigger: 'blur'},
        ],
        project_name: [
          {required: true, message: '请输入项目名称', trigger: 'blur'},
        ],
        place_order_money: [
          {required: true, message: '请输入下单金额', trigger: 'blur'},
        ],
        cooperative_ori_price: [{required: true, message: '必填', trigger: 'blur'},],
        iq_id: [{required: true, message: '请关联询单', trigger: 'blur'},],
      },
      orderTypeOptions: [
        {label: '冲账订单', value: 'strike'},
        {label: '普通订单', value: 'regular'},
      ],
      boolExecOptions: [
        {label: '已执行', value: 1},
        {label: '未执行', value: 0},
      ],
      payStatusOptions: [
        {label: '已完结', value: 2},
        {label: '部分回款', value: 1},
        {label: '待回款', value: 0},
      ],
      invoiceStatusOptions: [
        {label: '未开票', value: 'none'},
        {label: '部分开票', value: 'part'},
        {label: '全部开票', value: 'done'},
      ],
      //坑位选项
      adSpaceOptions: [],
      disabled: true,
    }
  },
  created() {
    this.getTmpOrders()
    //加载下拉框数据
    this.getOptions(this.optionsItem)
    //执行人员名单加载
    this.initOptionExecutor()
    // this.formatFromData()
  },
  methods: {
    setData: function () {
      if (this.needGetKol) {
        this.getKolList()
      } else {
        this.resetKolOptions()
      }
    },
    calRepelCheckValue(array, field) {
      if (Array.isArray(array) && array.length > 1) {
        const value_last = array ? array[array.length - 1] : null;
        const value_first = array ? array[0] : null;
        if (this.radioOptions.includes(value_last)) {
          this.formData[field] = [value_last]
        } else if (this.radioOptions.includes(value_first)) {
          this.formData[field].shift()
        }
      } else {
        this.formData[field] = this.formData[field] === null ? [] : this.formData[field]
      }
    },
    async getTmpOrders() {
      const {model} = await temporariesList()
      this.tmpOrders = model || []
    },
    refresh() {
      if (this.formData.id)
        this.$emit('refresh', this.formData.id)
    },
    showLog() {
      if (this.$refs['refOrderLog'])
        this.$refs['refOrderLog'].getList()

    },
    goBack() {
      this.$emit('goBack')
    },
    goNewAdd() {
      this.$emit('goNewAdd')
    },
    parseTime(time, cFormat) {
      return this.gFunc.parseTime(time, cFormat)
    },
    moneyFormat(val) {
      return this.gFunc.numberFormat(val, 2, '.', ',', 'round')
    },
    invoiceStatusFormat(val) {
      let item = this.invoiceStatusOptions.find(value => value.value === val)
      return item ? item.label : '未知'
    },
    payStatusFormat(val) {
      let item = this.payStatusOptions.find(value => value.value === val)
      return item ? item.label : '未知'
    },
    orderTypeFormat(val) {
      let item = this.orderTypeOptions.find(value => value.value === val)
      return item ? item.label : '未知'
    },
    //初始化执行列表
    initOptionExecutor() {
      getOptionExecutor().then(res => {
        this.executorOptions = res.model || [];
      });
    },
    //选项配置
    async getOptions(options) {
      const {model} = await getOptionRadios()
      this.radioOptions = model || []
      getOptionItems(options).then(res => {
        let data = res.model;
        const customerNaturesOptions = []
        const customerTypesOptions = []
        const orderSourceOptions = []
        const poiOptions = []
        const productCategoriesOptions = []
        const focOptions = []
        if (data.customer_natures) {
          Object.keys(data.customer_natures).forEach((k) => {
            customerNaturesOptions.push({label: data.customer_natures[k], value: k})
          })
        }
        if (data.customer_types) {
          Object.keys(data.customer_types).forEach((k) => {
            customerTypesOptions.push({label: data.customer_types[k], value: k})
          })
        }
        if (data.order_source) {
          Object.keys(data.order_source).forEach((k) => {
            orderSourceOptions.push({label: data.order_source[k], value: k})
          })
        }
        if (data.passenger_order_interval) {
          Object.keys(data.passenger_order_interval).forEach((k) => {
            poiOptions.push({label: data.passenger_order_interval[k], value: k})
          })
        }
        if (data.product_category) {
          Object.keys(data.product_category).forEach((k) => {
            productCategoriesOptions.push({label: data.product_category[k], value: k})
          })
        }
        if (data.form_of_cooperation) {
          Object.keys(data.form_of_cooperation).forEach((k) => {
            focOptions.push({label: data.form_of_cooperation[k], value: k})
          })
        }
        if (data.platforms) {
          this.platformOptions = []
          Object.keys(data.platforms).forEach((k) => {
            this.platformOptions.push({label: data.platforms[k], value: k})
          })
        }
        if (data.content_forms) {
          this.contentFormsOptions = []
          Object.keys(data.content_forms).forEach((k) => {
            this.contentFormsOptions.push({label: data.content_forms[k], value: k})
          })
        }
        if (data.pay_methods) {
          this.payMethodOptions = []
          Object.keys(data.pay_methods).forEach((k) => {
            this.payMethodOptions.push({label: data.pay_methods[k], value: k})
          })
        }
        if (data.ad_space) {
          this.adSpaceOptions = []
          Object.keys(data.ad_space).forEach((k) => {
            this.adSpaceOptions.push({label: k, value: data.ad_space[k]})
          })
        }

        // 设置客户资料下拉选项
        this.$refs.partyA && this.$refs.partyA.setOptions({
          customerNaturesOptions,
          customerTypesOptions,
          orderSourceOptions,
          poiOptions,
          productCategoriesOptions,
          focOptions
        })
      })
    },
    //编辑字段
    selectEditField(field) {
      this.editField = field
    },
    clearEditField() {
      //清空当前编辑字段
      this.editField = null
    },
    /**
     * 获取红人名称输入建议
     */
    async getKolList(val) {
      await getFBoyOption({
        nickname: val || this.formData.artist_name
      }).then((_list) => {
        this.kolOptions = _list.model || []
      });
    },
    async resetKolOptions() {
      await this.getKolList()
      const {artist_ids} = this.formData
      const kolOptions = this.kolOptions
      const options = []
      if (Array.isArray(artist_ids) && Array.isArray(kolOptions)) {
        artist_ids.map(_ => {
          const tmp = kolOptions.find(item => {
            return item.id === _
          })
          if (tmp) {
            options.push(tmp)
          }
        })
      }
      this.kolOptions = options
      this.key = new Date().getTime() + ''
    },
    selectFavouriteBoy(value) {
      let row = this.kolOptions.find(val => val.value === value)
      this.formData.artist_name = row ? row.nickname : ''
      this.formData.agent_name = row ? row.agent_name : ''
      this.formData.artist_id = row ? row.id : ''
    },
    // 暂存
    async onTmpSubmit() {
      let obj = this.formData
      this.onTmpSubmitLoadding = true
      obj.handleType = this.type
      const tmpIndex = this.$route.query && this.$route.query.tmpIndex
      if (tmpIndex > -1) {
        // 编辑
        this.tmpOrders[tmpIndex] = obj
      } else {
        // 新增
        if (!obj.customer_id) {
          this.showToast({
            h: this,
            text: "客户信息不能为空",
            icon: "el-icon-warning"
          });
          this.onTmpSubmitLoadding = false
          return false
        }
        const length = this.tmpOrders.length
        if (length >= 10) {
          this.tmpOrders.shift()
        }
        this.tmpOrders.push(obj)
      }
      const response = await temporariesSave({orders: this.tmpOrders})
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      setTimeout(() => {
        this.onTmpSubmitLoadding = false
        this.goBack()
      }, 1500)
    },
    closeSubmitLoading(time = 1000) {
      setTimeout(() => {
        this.onSubmitLoadding = false
      }, time)
    },
    // 保存 || 修改
    onSubmit(formName) {
      let _this = this;
      const formPartyA = _this.$refs.partyA.validateForm();
      const formPartyB = _this.$refs.partyB.validateForm();
      if (!formPartyA) {
        _this.$notify.warning('客户信息不完善，请仔细核对')
        _this.toAnchorPoint('partyA');
        return false
      }
      if (!formPartyB) {
        _this.$notify.warning('乙方信息不完善，请仔细核对')
        _this.toAnchorPoint('partyB');
        return false
      }
      if (_this.$refs.partBaseInquiry) {
        const formInquiry = _this.$refs.partBaseInquiry.validateForm();
        if (!formInquiry) {
          _this.$notify.warning('关联询单不完善，请仔细核对')
          return false
        }
      }

      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.onSubmitLoadding = true
          if (this.formData.id) {
            //修改订单-直接提交
            _this.formSubmit()
          } else {
            //创建订单-验证相似，选择是否添加
            postOrdersVerifyUnique({
              customer_id: this.formData.customer_id,
              brand: this.formData.brand,
              artist_id: this.formData.artist_id,
              product: this.formData.product,
              payment_account: this.formData.payment_account,
              release_timestamp: this.formData.release_timestamp
            })
                .then((res) => {
                  if (res.model) {
                    _this.formSubmit()
                  } else {
                    _this.showModal({
                      text: '相似订单已存在，是否继续添加？',
                      h: _this,
                      confirm: () => {
                        _this.formSubmit()
                      },
                      cancel: () => {
                        _this.closeSubmitLoading()
                      }
                    })
                  }
                })
                .catch(() => {
                  _this.closeSubmitLoading()
                })
          }
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })

    },
    formSubmit() {
      const h = this.$createElement;
      this.$msgbox({
        title: '提交订单信息',
        message: h('div', null, [
          // h('b', null, '基本信息 '),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `客户：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.customer_name}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `乙方：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.company_name}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `销售：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.sale}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `执行：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.executor}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `红人：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.artist_name}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `含税收入：`),
            h('span', {style: 'color: #ff3176'}, `${this.moneyFormat(this.formData.payment_account)}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `广告收入：`),
            h('span', {style: 'color: #ff3176'}, `${this.moneyFormat(this.formData.adv_revenue)}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `广告执行价：`),
            h('span', {style: 'color: #ff3176'}, `${this.moneyFormat(this.formData.exec_price)}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `实际所得：`),
            h('span', {style: 'color: #ff3176'}, `${this.moneyFormat(this.formData.real_income)}`),
          ]),
          h('div', null, [
            h('b', {style: 'color: #303133'}, `发布平台：`),
            h('span', {style: 'color: #ff3176'}, `${this.formData.platforms.join('、')}`),
          ]),
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '提交中...';
            this.onSubmitLoadding = true
            //若内容形式不保护视频合集植入
            if (this.formData.content_forms.indexOf('视频合集植入') === -1)
              this.formData.ad_space_id = null
            //判断是不是普客订单

            if (this.formData.project_type === 3) {
              this.formData.covenant_id = !this.formData.covenant_id ? 0 : this.formData.covenant_id
              //主单id
              let mainId = this.$route.query && this.$route.query.source_id
              this.formData.puke_id = this.formData.puke_id ? this.formData.puke_id : Number(mainId)
            }

            let isSubmit = true;
            if (this.isPureLive === true && this.formData.payment_account > 0 &&
                ((this.formData.invest_flow_fee | 0) + (this.formData.cart_commission | 0) + (this.formData.offline_rebate | 0)) <= 0
            ) {
              isSubmit = false;
              this.$message.error('含税收入>0时，需 投流费+直播坑位费+线下结佣 > 0');
              this.onSubmitLoadding = false
            }

            if (isSubmit) {
              await createOrder(this.formData).then((res) => {
                this.onSubmitLoadding = false
                if (res.success) {
                  this.$emit('saved', res.model.id)
                } else {
                  this.$notify.warning(`保存失败：${res.message || '未知'}`)
                }
              })
            }
            //数据提交后
            done();
            instance.confirmButtonLoading = false;
          } else {
            done();
          }
        }
      })
          //     .then(action => {
          //   // this.$message({
          //   //   type: 'info',
          //   //   message: 'action: ' + action
          //   // });
          // })
          .catch(action => {
            this.$message({
              type: 'info',
              message: action === 'cancel'
                  ? '放弃保存'
                  : '停留在当前页面'
            })
            this.onSubmitLoadding = false
          });
    },
    /**
     * 滑动
     * @param dom
     */
    toAnchorPoint(dom) {
      const offsetTop = this.$refs[dom].$el.offsetTop - 100 || false
      // Chrome
      document.body.scrollTop = offsetTop
      // Firefox
      document.documentElement.scrollTop = offsetTop
    },
    selectedExecutor(val) {
      let option = this.executorOptions.find(value => value.value === val)
      this.formData.executor = option ? option.label : ''
      this.clearEditField();
    },
    selectedUser(option, roleName) {
      let data = null
      switch (roleName) {
        case 'Medium':
          this.$set(this.formData, 'medium_name', option ? option.name : '')
          this.formData.medium_name = option ? option.name : ''
          break
        case 'Planner':
          this.$set(this.formData, 'planner_name', option ? option.name : '')
          this.formData.planner_name = option ? option.name : ''
          break
        case 'Strategy':
          data = Array.isArray(option) ? option.map(_ => {
            return _.name || ''
          }) : null
          this.formData.strategy_name = data
          this.$set(this.formData, 'strategy_name', option ? data : null)
          if (!data) {
            this.strategyNameLabel = null;
          } else if (Array.isArray(data)) {
            this.strategyNameLabel = data.join('、');
          } else {
            this.strategyNameLabel = data;
          }
          break
      }
      this.$forceUpdate()
      this.clearEditField()
    },
    handelPreviewFiles(obj) {
      const {href} = this.$router.resolve({
        name: `FilesPreview`,
        query: {
          covenant_id: obj.covenant_id,
        }
      });
      window.open(href, "_blank");
    },
  }
}
</script>

<style lang="scss">
.order-part-base-container {

  .card-title {
    position: relative;
    padding-left: 55px;
    margin-bottom: 8px;
    margin-top: 12px;
    color: rgba(50, 50, 50, 1);
    line-height: 24px;
    font-size: 14px;
    font-weight: bold;
    text-align: left;
  }

  .card-title::after {
    content: "";
    position: absolute;
    bottom: 6.5px;
    left: calc(55px - 8px - 6px);
    width: 8px;
    height: 8px;
    background: rgba(224, 63, 61, 1);
    border-radius: 2px;

  }

  .form-card {
    padding: 24px 20px;
    border-radius: 6px;
    border: 1px solid rgba(221, 221, 221, 1);
    width: 95%;
    margin: 5px auto;
  }

  .form-rows {
    border: 1px solid rgba(221, 221, 221, 1);
    border-radius: 6px;
    padding: 20px;
  }

  .op-row {
    text-align: center;
    vertical-align: middle;
    /*border: 1px solid rgba(221, 221, 221, 1);*/
    border-radius: 6px;
    line-height: 1;
    padding: 24px 20px;
  }

  .btn-operation {
    border-radius: 2px;
    font-size: 14px;
    padding: 12px 20px;
  }

  .edit-btn {
    margin-left: 5px;
  }

  .is-label {
    font-weight: 800;
    color: #606266;
  }

  .is-value {
    font-weight: 400;
    margin-right: 10px;
    color: #606266;
  }

  .rebates_rate::after, .commission_rate::after, .commission_trailer::after {
    content: ' %';
  }

  .calc-res {
    font-weight: 600;
    font-size: 1.2em;
    color: #F56C6C;
  }

  .switch-val {
    min-width: 120px;
    width: 180px;
    max-width: 300px;
    overflow-x: hidden;
    text-align: center;
    vertical-align: middle;
    margin-bottom: 5px;
    border-radius: 4px;
    display: inline-block;
    line-height: 1.2;
  }

  .span-val {
    min-width: 120px;
    width: 180px;
    max-width: 300px;
    overflow-x: hidden;
    text-align: center;
    border: 1px solid rgb(220, 223, 230);
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 4px;
    display: inline-block;
    font-size: 1em;
    line-height: 24px;
  }

  .input-val {
    min-width: 120px;
    width: 180px;
    max-width: 300px;
    overflow-x: hidden;
    text-align: center;
    border: 1px solid rgb(220, 223, 230);
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 4px;
    cursor: pointer;
    display: inline-block;
    font-size: 1em;
    line-height: 24px;
  }

  .input-val > .form-val {
    flex: 4;
    text-align: center !important;
    width: 100%;
  }

  .input-val > .edit-btn {
    flex: 1;
  }

  .fee-box {
    border: 1px solid rgb(220, 223, 230);
    padding: 10px;
  }

  .bold-label {
    font-weight: bold;
    color: #ff3176;
  }

  .form-card.disabled {
    .input-val {
      background: #F2F2F2;
      color: #636466;
      cursor: not-allowed;
      pointer-events: none; // 禁止点击事件
    }
  }


  .fee {
    $LabelWidth: 115px;
    $PaddingRight: 14px;

    .tip {
      width: 241px;
      border: 1px solid #F2F2F2;
      padding-left: 8px;
      padding-top: 24px;
      border-radius: 5px;
      box-shadow: 0 0 8px rgba(0, 0, 0, .3);
    }

    .el-form-item {
      margin-right: 0;
      margin-bottom: 14px;
    }

    .input-val {
      min-width: unset;
      width: calc(100% - 12px);
      max-width: unset;
      overflow-x: hidden;
    }


    .item {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;

      .el-form-item {
        padding-right: $PaddingRight;

        .el-form-item__label {
          width: $LabelWidth;
        }

        .el-form-item__content {
          width: calc((100% - #{$LabelWidth}));
        }
      }

    }

    .item {
      @media only screen and (min-width: 1200px) {
        .el-form-item {
          width: calc((33.33% - #{$PaddingRight}));
        }
      }

      @media only screen and (min-width: 1380px) {
        .el-form-item {
          width: calc((25% - #{$PaddingRight}));
        }
      }
    }
  }

  .custom-checkbox-form {
    .el-form-item__content {
      width: calc(100% - 80px);
    }

    .el-checkbox {
      margin-right: 12px;
      line-height: 20px
    }
  }

  .el-form-item {
    margin-bottom: 14px;
  }

  .ploy-row {
    .el-form-item__label:before {
      content: "*";
      color: #FFF;
      margin-right: 4px;
    }
  }

  .tags {
    .el-tag {
      border-radius: 9px;
      line-height: 16px;
      height: 18px;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.disabledNick {
  background: #F2F2F2;
  color: #636466;
  cursor: not-allowed;
  pointer-events: none; // 禁止点击事件
}

.party-row {
  display: flex;
  padding: 20px;

  .card-model {
    width: 50%;
  }
}
</style>
